import { requireGuest } from '@portal/features/auth/guards'
import MainLayout from '@portal/features/layouts/MainLayout'
import { Header } from '@portal/features/navigation/Header'
import SupportEmailButton from '@portal/features/support/SupportEmailButton'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const RouteComponent = () => {
  return (
    <MainLayout>
      <Header.Right>
        <SupportEmailButton />
      </Header.Right>
      <Outlet />
    </MainLayout>
  )
}

export const Route = createFileRoute('/signin')({
  beforeLoad: requireGuest,
  component: RouteComponent,
})
